import React, { Fragment } from "react"
import FlowGraph from "../../dashboard/FlowGraph"

const KnowledgeFingerprintWidget = ({ fingerprint }) => {
    const flow = fingerprint.map(({ name, score }) => ({
        key: name,
        count: score,
    }))
    return (
        <FlowGraph
            flow={flow}
            maxValue={1}
            renderHeader={() => (
                <Fragment>
                    <span className="icon icon-concepts" />
                    Fingerprint
                    <span className="widget-header-info">{flow.length}</span>
                </Fragment>
            )}
        />
    )
}

export default KnowledgeFingerprintWidget
